import axios from "axios"

export const getCategories = async (url) => {
  console.log("Fetching Product Categories")
  try {
    const response = await axios.get(`${url}categories/`)
    return { success: true, data: response.data }
  } catch (err) {
    console.error("Error Fetching Categories:", err, err?.response)
    return { success: false, error: err.message }
  }
}

export const getProducts = async (url) => {
  console.log("Fetching Products")
  try {
    const response = await axios.get(`${url}`)
    return { success: true, data: response.data }
  } catch (err) {
    console.error("Error Fetching Products:", err, err?.response)
    return { success: false, error: err.message }
  }
}
